var map = {
	"./ei_transfers_icon.svg": 1097,
	"./mainNavigationChevron_icon.svg": 1098,
	"./schedule_icon.svg": 1099,
	"./sports-news_icon.svg": 1100,
	"./sports_icon.svg": 1101,
	"./table_icon.svg": 1102,
	"./transfers_icon.svg": 1103,
	"./worldnews_icon.svg": 1104
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1319;


//////////////////
// WEBPACK FOOTER
// ./provolution/app/views/provolution/common_assets/images ^\.\/.*_icon\.svg$
// module id = 1319
// module chunks = 15